import type { FC } from "react";
import { promoBannerSkeleton } from "./PromoBannerSkeleton.styles";

export const PromoBannerSkeleton: FC = () => (
  <div className={promoBannerSkeleton} aria-hidden="true" data-testid="promo-banner-skeleton" />
);
